import { isAnyOf } from "@reduxjs/toolkit";
import {
  allResumeFulfilledMatchers,
  allResumePendingMatchers,
  allResumeRejectedMatchers,
  resumeApi,
} from "../../api/resumeApi";
import {
  createGenericState,
  onFulfilledMatcher,
  onPendingMatcher,
  onRejectMatcher,
} from "../genericState/genericState";
import { OnboardingState } from "../onboarding/onboarding.slice";

const initialState: OnboardingState = {
  isLoading: false,
  isError: false,
  isSuccess: false,
  isUninitialized: true,
  error: undefined,
  data: undefined,
  currentStep: 0,
  redirectError: undefined,
};

export const resumeSlice = createGenericState("@Resume", initialState, {
  extraReducers: builder => {
    builder
      .addMatcher(
        resumeApi.endpoints.resumeNext.matchPending,
        (state, action) => {
          state.stepValues = action.meta.arg.originalArgs.values;
        },
      )
      .addMatcher(isAnyOf(...allResumePendingMatchers), (state, action) => {
        onPendingMatcher(state, action);
      })
      .addMatcher(isAnyOf(...allResumeRejectedMatchers), (state, action) => {
        onRejectMatcher(state, action);
      })
      .addMatcher(isAnyOf(...allResumeFulfilledMatchers), (state, action) => {
        onFulfilledMatcher(state, action);
      });
  },
});

export const resumeActions = {
  ...resumeSlice.actions,
};
export default resumeSlice;
